import { Link, useParams } from "react-router-dom";
import { t } from "../lib/i18n";

export default function OrderSuccess() {
  const { lang = "en" } = useParams();
  const zh = lang === "zh";
  return <section className="container-page py-12"><div className="panel p-6"><h1 className="text-3xl font-black">{t(lang, "orderSuccess")}</h1><p className="mt-3 text-slate-600">{zh ? "你的订单已创建。请前往付款页面查看手动付款说明。" : "Your order was created. Continue to payment instructions."}</p><Link className="btn-primary mt-5" to={`/${lang}/order-lookup`}>{zh ? "查询订单" : "Look up order"}</Link></div></section>;
}
